import { CompanyConfiguration } from "./company-configuration";
import { UntypedFormGroup } from "@angular/forms";

interface ICompanyConfigurationHandler {
  handleCompanyConfigurationToForm(CompanyConfiguration: CompanyConfiguration): void;
}

export class CompanyConfigurationHandler implements ICompanyConfigurationHandler {
  constructor(private formCompanyConfiguration: UntypedFormGroup) {}

  handleCompanyConfigurationToForm(companyConfiguration: CompanyConfiguration): void {
    this.formCompanyConfiguration.patchValue({
      transactionalLimit: companyConfiguration.getTransactionalLimit(),
      hasTransactionalLimit: companyConfiguration.isHasTransactionalLimit(),
    });
  }
}
